
import { Guid } from 'guid-typescript';

export default class Utils {
  /**
   * 获取Guid字符串
   */
  public Guid(): string {
    return Guid.create().toString();
  }

  /**
   * 字符串转对象取代eval
   * @param str
   */
  public Evil(str: string) {
    const Fn = Function; // 一个变量指向Function，防止有些前端编译工具报错
    return new Fn('return ' + str)();
  }

  private get Vue(): any {
    return window["Vue"] as any;
  }

  public Success(message: string) {
    this.Vue.$alert(message, this.Vue.$t("global.prompt"), { type: "success" });
  }

  public Error(message: string) {
    this.Vue.$alert(message, this.Vue.$t("global.prompt"), { type: "error" });
  }

  public Info(message: string) {
    this.Vue.$alert(message, this.Vue.$t("global.prompt"), { type: "info" });
  }

}
